import { CoingeckoImg } from "app/constants";

const CoingeckoIcon = () => {
  return <img width="24" height="24" src={CoingeckoImg} alt="Coingecko-icon" />;
};

export default CoingeckoIcon;
